import { gql } from '@grandvisionhq/graphql';

const GET_PAYMENT_DATA_BY_TOKEN = gql`
  query GetPaymentByToken($input: GetPaymentByToken!) {
    getPaymentByToken(input: $input) {
      failures {
        ... on InvalidPspPaymentToken {
          message
        }
      }
      response {
        id
        psp
        ... on PaypalPayment {
          id
          psp
          status
          customerDetails {
            email
            firstName
            lastName
            phone
          }
          shippingAddress {
            firstName
            lastName
            addressLine1
            addressLine2
            city
            state
            postalCode
            countryCode
          }
          amount {
            centAmount
            currencyCode
          }
          customId
        }
      }
    }
  }
`;

export { GET_PAYMENT_DATA_BY_TOKEN };
//# sourceMappingURL=get-payment-by-token.js.map
